module.exports = __webpack_public_path__ + "img/backpic_snow.6739cbde.svg";